import 'css-chunk:src/app/containers/Home/ClientsView/ClientDetailView/ContentFields/ContentFields.scss';export default {
  "contentFieldsContainer": "_contentFieldsContainer_8ojse_1",
  "newContentField": "_newContentField_8ojse_7"
};